import { Injectable } from '@angular/core';
import { SessionService } from '../StoreService/SessionService/session.service';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class LogoutService {

  constructor(
    private sessionService: SessionService,
    private router: Router
  ) { }

  logout() {
    this.sessionService.newUser(null);
    localStorage.removeItem("token");
    this.router.navigate(["/pb/log-in"]);
  }
}
